
import './App.css';
import Home from './component/Home';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Navbar from './component/Navbar';
import Contact from './component/Contact';
import Footer from './component/Footer';

import Muj from './component/Muj';
import Whatsapp from "./component/Whatsapp";


import Coursefilter from './component/Coursefilter';
import Smu from './component/Smu';
import Scrolltotop from './component/Scrolltotop';



function App() {

  return (
    <>
   <BrowserRouter>
   <Navbar></Navbar>
    <Scrolltotop />

   <Routes>
<Route path="/" element={<Home></Home>}></Route>
<Route path="/contact" element={<Contact></Contact>}></Route>
<Route path="/muj" element={<Muj></Muj>}></Route>
<Route path="/smu" element={<Smu></Smu>}></Route>
<Route
  path="/course/:courseName"
  element={<Coursefilter/>}
/>


   </Routes>

<Footer></Footer>
<Whatsapp />

   </BrowserRouter>
    
    </>
  );
}

export default App;
